import Vue from "vue";

const getters = {
    getCargos: (state) => {
        return _.orderBy( _.filter(state.cargo,c => {
            return c.orderIds && c.orderIds.length
        }), ['estimatedTimeOfDeparture.seconds'], ['asc']);
    },
    getIncomingCargos: (state) => {
        return _.orderBy(state.cargo, ['estimatedTimeOfArrival.seconds'], ['asc']);
    },
    getCargo: (state) => (id) => {
        return state.cargo[id] ? state.cargo[id] : false;
    },
    getCargoProgressData: (state, getters, rootState, rootGetters) => (id) => {
        // Getting all the orders from given cargo
        let orders = _.filter(rootGetters['orders/getOrders'], {'cargoId': parseInt(id)});

        // Object to keep count of values
        let progressData = {
            loaded: 0,
            unknownBarcode: 0,
            available: 0,
            notAvailable: 0,
            totalAmount: 0
        };

        // Loop all orders to get all the products
        _.each(orders, (order) => {
            let products = _.filter(rootGetters['orderProducts/getProducts'], {'orderId': parseInt(order.id)});

            // PER PRODUCT AMOUNT OPTELLEN, DIT IS HET AANTAL WAT BENODIGD IS VOOR DE ORDER.
            _.each(products, (product) => {
                let productNumber = product.productNumber;
                let availableProduct = _.find(rootGetters['products/getProducts'], {productNumber: productNumber});

                progressData.totalAmount += product.amount;

                // Check if product HAS a barcode
                if (!product.productNumber) {
                    progressData.unknownBarcode += product.amount;
                } else {
                    // Get already picked amount
                    let alreadyPickedAmount = rootGetters['pickLocations/getPicklocations']([product.orderId]);
                    let availableStock = 0;
                    _.each(alreadyPickedAmount, product => {
                        progressData.available += product.amount;
                        progressData.loaded += product.amountPicked;
                        availableStock += product.amount;
                    });

                    if (!alreadyPickedAmount) {
                        progressData.notAvailable++;
                    }

                    // Count total available stock for all locations together
                    if (availableProduct) {

                        let productsLeftToPick = product.amount - progressData.loaded;
                        let canUseStock = availableStock - progressData.loaded - productsLeftToPick;
                        if (canUseStock < 0) {
                            // progressData.available += availableStock - progressData.loaded
                            progressData.notAvailable += Math.abs(canUseStock);
                        } else {
                            // progressData.available += productsLeftToPick
                        }
                    }
                }
            });
        });
        return progressData;
    }
};

export default getters;